import { reducer as confirm } from "./confirm/slice";
import { reducer as deliveries } from "./deliveries/slice";
import { reducer as detail } from "./detail/slice";

export const reducer = {
  deliveries,
  detail,
  confirm,
};
